var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceBalanceHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9976_4677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.005 32.89H27.981V30.188M25.005 4H27.981V14.134M27.98 4H5.75V32.89H26.404M9.74 12.236H23.976M9.74 8.182H23.976M9.74 15.791H16.866M9.74 19.507H16.866M9.74 23.544H16.866M9.74 27.582H16.866",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.98 29.6569C30.0407 29.6569 32.017 28.8383 33.4742 27.3812C34.9313 25.924 35.75 23.9477 35.75 21.8869C35.75 19.8262 34.9313 17.8499 33.4742 16.3927C32.017 14.9356 30.0407 14.1169 27.98 14.1169C25.9192 14.1169 23.9429 14.9356 22.4857 16.3927C21.0286 17.8499 20.21 19.8262 20.21 21.8869C20.21 23.9477 21.0286 25.924 22.4857 27.3812C23.9429 28.8383 25.9192 29.6569 27.98 29.6569Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3659 18.4449V22.8529H25.0049",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9976_4677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBalanceHistory);
export default __webpack_public_path__ + "static/media/serviceBalanceHistory.ea8ca22b12096601f48b735139061dbd.svg";
export { ForwardRef as ReactComponent };